import HTMLEntities from "./HTML.entities";
import * as _ from "underscore";
import moment from "moment";

export const SuperUtils = {

    /**
    * Convertit un blob en base64
    * @param blob Blob
    */
    blobToBase64(blob: Blob): Promise<any> {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    },

    getAge(birthday: moment.Moment, fromDate: moment.Moment = moment()) {
        const age = +fromDate.diff(birthday, 'years', true);
        const decimal = age % 1
        const year_old = Math.floor(age)
        const year_month = Math.floor(12 * decimal)
        return [year_old, year_month]
    },

    /**
    * Renvoie une icone à la place d'un boolean
    * @param value boolean true / false / 1 / 0
    */
    showBoolean: (value) => {
        // console.log(value)
        if (value) {
            return `✅`
        } 
        else if (value === -1) {
            return `⌛`;
        } 
        else {
            return `❌`
        }
    },

    /**
    * Transforme en objet Date
    * @param input l'objet qui va être convertit
    */
    formatDate: (input) => {
        return moment(input).isValid() ? moment(input).toDate() : null
    },

    /**
    * Retourne une chaine de caractère ou tous les caractères spéciaux ont été transformés en lettre simple
    * @param chaine la chaine qui va être formattée
    */
    sanitizeName: (chaine: string): string => {
        var tab1 = " 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüÿÑñ-";
        var tab2 = "__aaaaaaaaaaaaooooooooooooeeeeeeeecciiiiiiiiuuuuuuuuynn_";
        var rep1 = tab1.split("");
        var rep2 = tab2.split("");
        var myarray: any = [];
        rep1.map((rep: any, i) => {
            myarray[rep] = rep2[i];
        });
        myarray["Œ"] = "OE";
        myarray["œ"] = "oe";

        chaine = chaine.replace(/\//g, "_").replace(/\\/g, "_");

        return chaine.replace(/./g, function ($0: any) {
            return myarray[$0] ? myarray[$0] : $0;
        });
    },

    /**
    * Retourne une chaine aléatoire avec une longueur de 6 caractères par défaut
    * @param options Options pour générer la chaine aléatoire 
    * @param options.maj boolean => ABCDEFGHIJKLMNOPQRSTUVWXYZ (true par défaut)
    * @param options.min boolean => abcdefghijklmnopqrstuvwxyz (true par défaut)
    * @param options.number boolean => 0123456789 (true par défaut)
    * @param options.length number : Longueur de la chaine alétoire (6 par défaut)
    */
    randomString(options = {
        maj: true,
        min: true,
        number: true,
        length
    }) {
        const length = options.length || 6
        var result = '';
        const characters = `${options.maj ? "ABCDEFGHIJKLMNOPQRSTUVWXYZ" : ""}${options.min ? "abcdefghijklmnopqrstuvwxyz" : ""}${options.number ? "0123456789" : ""}`;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    },

    /**
    * Retourne la chaine de caractère avec la première lettre en majuscule
    * @param chaine la chaine qui va être formattée
    */
    capitalize: (string: string): string => {
        return string && string.charAt(0).toUpperCase() + string.slice(1);
    },

    decodeHex: (text: string) => {
        if (_.isString(text) && text.length > 0) {
            var entities = HTMLEntities;
            for (var i = 0, max = entities.length; i < max; ++i)
                text = text.replace(
                    new RegExp(entities[i].code, "g"),
                    entities[i].value
                );

            return text;
        } else return text;
    },

    getMatches: (string: string, regex: RegExp, index: number) => {
        index || (index = 1); // default to the first capturing group
        var matches = [];
        var match;
        while ((match = regex.exec(string))) {
            matches.push(match[index]);
        }
        return matches;
    },

    getRandomInt: (min: number, max: number): number => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    sanitizeHtml: (html: string): string => {
        return html.replace(/<[\s\S]*?>/gi, "");
    },


    SuperSorter: (fields) => (a, b) => fields.map(o => {
        let dir = 1;
        if (o[0] === '-') { dir = -1; o = o.substring(1); }
        return a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
    }).reduce((p, n) => p ? p : n, 0),

}